var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473.45 52.33C473.45 52.33 473.45 52.33 473.45 52.33C473.47 371.56 473.49 548.91 473.49 584.38C473.49 584.38 473.49 584.38 473.49 584.38C289.26 584.4 186.91 584.4 166.44 584.4C166.44 584.4 166.44 584.4 166.44 584.4C166.42 265.17 166.4 87.82 166.4 52.35C166.4 52.35 166.4 52.35 166.4 52.35C350.63 52.34 452.98 52.33 473.45 52.33Z",
    id: "a22id3aipJ"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M380.9 320.01C380.9 353.75 353.55 381.1 319.81 381.1C286.08 381.1 258.73 353.75 258.73 320.01C258.73 286.28 286.08 258.93 319.81 258.93C353.55 258.93 380.9 286.28 380.9 320.01Z",
    id: "cpd89SSHN"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M625.85 318.29C625.85 318.29 625.85 318.29 625.85 318.29C349.4 477.92 195.82 566.61 165.1 584.35C165.1 584.35 165.1 584.35 165.1 584.35C72.97 424.81 21.79 336.17 11.56 318.45C11.56 318.45 11.56 318.45 11.56 318.45C288.01 158.81 441.59 70.12 472.31 52.39C472.31 52.39 472.31 52.39 472.31 52.39C564.43 211.93 615.62 300.56 625.85 318.29Z",
    id: "a1AzV1Ef9P"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M472.35 585.41C472.35 585.41 472.35 585.41 472.35 585.41C195.87 425.82 42.28 337.15 11.56 319.42C11.56 319.42 11.56 319.42 11.56 319.42C103.66 159.87 154.83 71.23 165.06 53.5C165.06 53.5 165.06 53.5 165.06 53.5C441.54 213.09 595.13 301.76 625.85 319.49C625.85 319.49 625.85 319.49 625.85 319.49C533.75 479.04 482.58 567.69 472.35 585.41Z",
    id: "au45V8Mxs"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.81 269.29C291.8 269.29 269.1 292 269.1 320.01C269.1 348.02 291.8 370.73 319.81 370.73C347.83 370.73 370.53 348.02 370.53 320.01C370.53 292 347.83 269.29 319.81 269.29Z",
    id: "a1EmL9JX4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M319.81 279.29C297.32 279.29 279.09 297.52 279.09 320.01C279.09 342.5 297.32 360.73 319.81 360.73C342.31 360.73 360.54 342.5 360.54 320.01C360.54 297.52 342.31 279.29 319.81 279.29Z",
    id: "b8HRSpFMh"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M350.17 320.01C350.17 336.78 336.58 350.37 319.81 350.37C303.05 350.37 289.46 336.78 289.46 320.01C289.46 303.25 303.05 289.65 319.81 289.65C336.58 289.65 350.17 303.25 350.17 320.01Z",
    id: "c18pnjlSks"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M319.81 299.65C308.57 299.65 299.45 308.77 299.45 320.01C299.45 331.26 308.57 340.37 319.81 340.37C331.06 340.37 340.18 331.26 340.18 320.01C340.18 308.77 331.06 299.65 319.81 299.65Z",
    id: "bnO5Jg8ZK"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.81 310.02C314.29 310.02 309.82 314.49 309.82 320.01C309.82 325.53 314.29 330.01 319.81 330.01C325.34 330.01 329.81 325.53 329.81 320.01C329.81 314.49 325.34 310.02 319.81 310.02Z",
    id: "d1c7QlrToI"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M165.44 587.67L10.69 320.01L165.44 52.35L474.56 52.35L476.04 54.57L629.31 320.01L627.83 322.23L474.56 587.67L165.44 587.67ZM469.38 578.79L618.57 320.01L469.01 61.24L170.62 61.24L21.06 320.01L170.62 578.79L469.38 578.79Z",
    id: "cnYjCJ7kt"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M382.75 88.26C382.75 88.26 382.75 88.26 382.75 88.26C382.75 347.7 382.75 491.84 382.75 520.66C382.75 520.66 382.75 520.66 382.75 520.66C306.12 520.66 263.54 520.66 255.03 520.66C255.03 520.66 255.03 520.66 255.03 520.66C255.03 261.22 255.03 117.09 255.03 88.26C255.03 88.26 255.03 88.26 255.03 88.26C331.66 88.26 374.24 88.26 382.75 88.26Z",
    id: "d1vV5oakOj"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientatWxAMys2",
    gradientUnits: "userSpaceOnUse",
    x1: 254.92,
    y1: 304.3,
    x2: 382.79,
    y2: 304.3
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccb010",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3c900",
      stopOpacity: 1
    },
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8e000",
      stopOpacity: 1
    },
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8e000",
      stopOpacity: 1
    },
    offset: "100%"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M382.75 87.89C382.75 88.71 354.08 89.37 318.7 89.37C283.33 89.37 254.66 88.71 254.66 87.89C254.66 87.07 283.33 86.41 318.7 86.41C354.08 86.41 382.75 87.07 382.75 87.89Z",
    id: "c1Km1NHy3J"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M451.61 104.55C451.61 104.55 436.06 113.07 428.66 122.69C428.66 122.69 419.77 134.54 412.37 135.28C412 134.41 410.15 130.1 406.81 122.32L413.11 88.26L402.74 83.08C395.63 81.08 391.68 79.97 390.89 79.75C390.89 79.75 379.05 91.96 375.72 99.37C375.72 99.37 367.2 120.47 357.21 120.1C357.21 120.1 349.43 105.66 349.43 105.29C349.43 104.92 346.84 91.59 346.84 91.22C346.84 90.48 346.1 76.42 346.1 76.42C345.36 76.07 341.66 74.34 334.99 71.23C327.44 71.23 323.25 71.23 322.41 71.23C322.41 71.23 312.41 89 311.3 98.63C311.3 98.63 310.56 118.25 296.49 120.1C282.42 121.95 278.35 94.19 278.35 94.19C278.23 93.57 277.61 90.48 276.5 84.93L265.76 79.75C258.43 82.41 254.36 83.89 253.55 84.19C253.55 84.19 249.48 98.63 250.96 112.33C250.96 112.33 256.14 138.61 236.15 137.87C234.86 136.88 228.45 131.95 216.9 123.06L215.05 116.77L213.2 113.81L202.09 107.88L191.35 115.29C192.02 123.28 192.39 127.73 192.46 128.61C192.46 128.61 195.05 139.72 198.39 146.01C198.39 146.01 208.75 171.19 186.91 170.45C186.84 170.47 186.47 170.6 185.8 170.82C179.58 166.38 176.13 163.91 175.43 163.41C175.43 163.41 166.55 156.75 146.93 152.31C146.08 153.31 139.26 161.3 138.41 162.3C138.41 162.3 141.75 177.11 153.59 188.59C153.59 188.59 165.44 203.03 157.29 211.17C157.29 211.17 151.37 219.32 135.82 213.76C135.82 213.76 127.68 209.32 119.16 210.06C118.27 210.08 113.83 210.21 105.83 210.43L99.91 221.54C105.02 227.98 107.86 231.56 108.43 232.27C108.43 232.27 117.68 240.05 124.35 244.12C124.35 244.12 137.3 251.15 131.38 263C131.38 263 127.31 271.14 112.5 269.66C112.5 269.66 101.02 267.81 87.69 273C87.23 273.14 84.88 273.88 80.66 275.22C79.33 282.77 78.59 286.96 78.44 287.8C78.44 287.8 91.03 295.58 101.76 300.02C101.76 300.02 121.01 301.13 121.38 314.46C121.38 314.46 122.49 325.56 108.43 328.16C107.83 328.3 103.1 329.49 102.5 329.64C102.5 329.64 95.47 330.01 90.66 333.71C89.62 334.3 84.44 337.26 75.11 342.59L76.22 355.18L87.32 359.62C107.76 361.62 119.11 362.73 121.38 362.96C121.38 362.96 131.38 372.21 121.75 381.1C121.75 381.1 114.35 387.39 110.65 388.87C110.65 388.87 105.46 390.35 92.51 404.05C92.21 404.44 90.73 406.42 88.07 409.97L92.88 421.45L103.98 426.26C127.31 421.37 140.26 418.66 142.86 418.12C142.86 418.12 150.63 422.19 143.6 435.15C143.6 435.15 136.56 443.29 135.45 444.4C135.45 444.4 129.16 449.58 123.98 461.06C123.68 461.58 122.2 464.17 119.53 468.84L127.68 478.83L138.78 482.9L154.7 471.8C162.03 467.13 166.1 464.54 166.92 464.02C166.92 464.02 185.06 459.58 181.36 475.13C181.36 475.13 179.88 481.05 175.43 487.72C175.43 487.72 166.92 505.12 167.29 515.11C168.03 515.58 171.73 517.92 178.4 522.14L188.39 526.22C209.72 506 221.56 494.77 223.93 492.53C223.93 492.53 232.82 493.64 229.48 510.3C229.48 510.3 224.67 524.37 225.78 532.14C225.86 532.98 226.23 537.18 226.89 544.73C233.78 547.62 237.6 549.22 238.37 549.54C238.37 549.54 253.18 538.43 253.92 537.69C254.66 536.95 269.47 511.04 269.47 511.04C269.47 511.04 283.53 505.86 285.02 517.33C285.02 517.33 286.5 525.48 286.13 531.03C286.13 531.03 286.5 537.32 288.35 541.4C288.72 542.41 290.57 547.47 293.9 556.57L305.01 560.65C319.67 528.22 327.81 510.2 329.44 506.6C329.44 506.6 339.81 504 346.47 518.44C346.47 518.44 347.58 526.22 355.73 536.95C356.14 537.5 358.24 540.21 362.02 545.1L373.12 549.91C380.23 546.58 384.18 544.73 384.97 544.36C384.97 544.36 380.53 525.48 380.53 524.74C380.53 524 376.09 501.04 376.83 498.82C377.2 496.6 388.3 485.86 389.04 485.86C389.78 485.86 400.15 490.68 404.22 498.08C404.22 498.08 409.78 507.71 425.69 516.96C426.46 517.31 430.28 519.04 437.17 522.14L440.13 519.55L438.65 505.49L435.69 494.01L367.57 382.95L367.57 378.13C360.46 375.02 356.51 373.3 355.73 372.95C355.73 372.95 337.96 386.28 326.48 388.13C326.48 388.13 306.49 394.42 285.39 386.28C283.2 386.39 265.73 387.28 263.54 387.39C263.54 387.39 236.15 346.67 236.52 344.08C236.89 341.48 247.62 293.36 252.07 288.17C256.88 282.62 273.91 263 276.5 262.63C279.09 261.89 330.92 250.04 330.92 250.04C330.92 250.04 365.35 244.86 369.79 240.79C374.24 236.71 414.59 176.74 416.81 175.26C419.03 173.78 449.76 132.32 450.87 131.95C451.61 131.58 463.09 110.1 463.09 110.1C460.79 108.99 452.76 105.11 451.61 104.55Z",
    id: "ajA7fLWQP"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.18 292.99C93.84 296.1 96.43 297.82 96.95 298.17C105.46 304.09 117.68 306.68 117.68 306.68C117.68 306.68 117.68 306.68 117.68 306.68C125.46 308.54 129.9 314.09 129.9 314.09C129.9 314.09 129.9 314.09 129.9 314.09C138.04 330.75 116.2 335.19 116.2 335.19C116.2 335.19 116.2 335.19 116.2 335.19C105.46 336.3 104.72 338.15 100.28 340C100.28 340 100.28 340 100.28 340C100.28 340 100.28 340 99.91 340C99.91 340 99.91 340 99.91 340C95.47 341.85 85.84 348.89 85.84 348.89C85.84 348.89 85.84 348.89 85.84 348.89C86.29 356 86.53 359.94 86.58 360.73C102.5 367.4 114.72 366.29 114.72 366.29C114.72 366.29 114.72 366.29 114.72 366.29C130.27 366.29 134.34 371.84 134.34 371.84C134.34 371.84 134.34 371.84 134.34 371.84C143.23 383.32 125.83 393.31 125.83 393.31C125.83 393.31 125.83 393.31 125.83 393.31C115.83 397.38 110.65 403.31 110.65 403.31C110.65 403.31 110.65 403.31 110.65 403.31C108.43 404.79 99.54 415.53 99.54 415.53C99.54 415.53 99.54 415.53 99.54 415.53L103.98 426.63C111.09 426.41 115.04 426.29 115.83 426.26C122.86 426.26 133.6 422.56 133.6 422.56C133.6 422.56 133.6 422.56 133.6 422.56C150.63 416.27 155.44 423.67 155.44 423.67C155.44 423.67 155.44 423.67 155.44 423.67C163.22 431.07 153.22 445.51 147.3 449.58C147.3 449.58 147.3 449.58 147.3 449.58C147.3 449.58 147.3 449.58 147.3 449.58C147.3 449.58 147.3 449.58 147.3 449.58C141.75 453.66 137.3 463.28 137.3 463.28C137.3 463.28 137.3 463.28 137.3 463.28C135.45 466.24 131.75 474.39 131.75 474.39C131.75 474.39 131.75 474.39 131.75 474.39L139.15 483.27C147.37 480.83 151.94 479.47 152.85 479.2C154.33 478.83 162.11 474.76 162.11 474.76C162.11 474.76 162.11 474.76 162.11 474.76C165.07 472.17 172.84 468.84 172.84 468.84C172.84 468.84 172.84 468.84 172.84 468.84C186.91 462.54 191.35 470.32 191.35 470.32C191.35 470.32 191.35 470.32 191.35 470.32C196.91 479.57 186.54 493.27 186.54 493.27C186.54 493.27 186.54 493.27 186.54 493.27C181.73 497.71 178.77 520.66 178.77 520.66C178.77 520.66 178.77 520.66 178.77 520.66L188.39 526.96C190.39 525.62 191.5 524.88 191.72 524.74C201.72 519.55 209.49 510.67 209.49 510.67C209.49 510.67 209.49 510.67 209.49 510.67C215.05 504 221.71 498.82 221.71 498.82C221.71 498.82 221.71 498.82 221.71 498.82C235.41 489.94 239.48 499.93 239.48 499.93C239.48 499.93 239.48 499.93 239.48 499.93C243.92 507.34 238.37 522.14 238.37 522.14C238.37 522.14 238.37 522.14 238.37 522.14C235.41 527.33 238 549.91 238 549.91C238 549.91 238 549.91 238 549.91L249.48 553.24C254.36 547.91 257.08 544.95 257.62 544.36C260.58 542.14 266.88 530.29 266.88 530.29C266.88 530.29 266.88 530.29 266.88 530.29C276.13 511.04 284.27 512.15 284.27 512.15C284.27 512.15 284.27 512.15 284.27 512.15C299.08 512.52 297.6 534.73 297.6 534.73C297.6 534.73 297.6 534.73 297.6 534.73C296.49 542.88 305.38 561.76 305.38 561.76C306.19 561.73 310.26 561.61 317.59 561.39C318.7 559.17 319.32 557.93 319.44 557.68C327.22 544.36 328.7 528.81 328.7 528.81C328.7 528.81 328.7 528.81 328.7 528.81C331.29 513.63 339.07 512.15 339.07 512.15C339.07 512.15 339.07 512.15 339.07 512.15C354.61 508.08 358.69 528.44 358.69 528.44C358.69 528.44 358.69 528.44 358.69 528.44C359.43 535.47 373.12 551.39 373.12 551.39C373.12 551.39 373.12 551.39 373.12 551.39C380.23 548.95 384.18 547.59 384.97 547.32C389.41 531.77 387.93 524 387.93 524C387.93 524 387.93 524 387.93 524C387.19 518.81 387.19 509.19 387.19 509.19C387.19 509.19 387.19 509.19 387.19 509.19C387.19 492.9 397.56 492.9 397.56 492.9C397.56 492.9 397.56 492.9 397.56 492.9C410.15 493.27 416.81 506.97 416.81 506.97C416.81 506.97 416.81 506.97 416.81 506.97C419.77 512.52 437.17 524 437.17 524C437.17 524 437.17 524 437.17 524C443.61 519.55 447.19 517.09 447.91 516.59C447.91 495.86 440.87 485.86 440.87 485.86C440.87 485.86 440.87 485.86 440.87 485.86C435.32 472.91 441.98 464.39 441.98 464.39C441.98 464.39 441.98 464.39 441.98 464.39C397.34 412.42 372.53 383.54 367.57 377.76C329.81 408.12 297.23 391.83 297.23 391.83C297.23 391.83 297.23 391.83 297.23 391.83C242.44 367.77 256.51 316.68 256.51 316.68C256.51 316.68 256.51 316.68 256.51 316.68C269.1 262.63 316.48 257.08 316.48 257.08C316.48 257.08 316.48 257.08 316.48 257.08C346.1 251.15 367.2 268.18 367.2 268.18C367.2 268.18 367.2 268.18 367.2 268.18C423.4 209.32 454.62 176.62 460.86 170.08C454.2 159.34 463.46 146.38 463.46 146.38C463.46 146.38 463.46 146.38 463.46 146.38C468.64 140.83 471.23 127.87 471.23 127.87C471.23 127.87 471.23 127.87 471.23 127.87C471.6 126.39 473.45 116.4 473.45 116.4C473.45 116.4 473.45 116.4 473.45 116.4L463.46 110.1C457.68 113.44 454.47 115.29 453.83 115.66C450.13 117.51 442.35 126.02 442.35 126.02C442.35 126.02 442.35 126.02 442.35 126.02C436.36 132.46 433.02 136.04 432.36 136.76C427.18 143.05 418.66 140.83 418.66 140.83C418.66 140.83 418.66 140.83 418.66 140.83C405.7 136.02 413.85 115.66 413.85 115.66C413.85 115.66 413.85 115.66 413.85 115.66C416.44 110.1 413.85 88.63 413.85 88.63C413.85 88.63 413.85 88.63 413.85 88.63L402.37 85.3C397.04 91.3 394.08 94.63 393.49 95.3C390.52 98.26 386.08 106.4 386.08 106.4C386.08 106.4 386.08 106.4 386.08 106.4C382.97 112.18 381.24 115.39 380.9 116.03C373.12 128.61 364.24 125.65 364.24 125.65C364.24 125.65 364.24 125.65 364.24 125.65C353.87 124.17 353.5 107.51 353.5 107.51C353.5 107.51 353.5 107.51 353.5 107.51C354.24 98.63 351.28 90.11 351.28 90.11C351.28 90.11 351.28 90.11 351.28 90.11C350.91 89.37 346.47 77.16 346.47 77.16C346.47 77.16 346.47 77.16 346.47 77.16L334.25 77.53C330.7 83.97 328.72 87.55 328.33 88.26C323.15 96.04 322.41 110.1 322.41 110.1C322.41 110.1 322.41 110.1 322.41 110.1C321.3 120.1 312.41 125.28 312.41 125.28C312.41 125.28 312.41 125.28 312.41 125.28C298.71 130.84 293.53 113.07 293.53 113.07C293.53 113.07 293.53 113.07 293.53 113.07C292.42 105.66 288.35 100.48 286.87 97.89C286.87 97.89 286.87 97.89 286.87 97.89C285.39 95.67 277.24 86.04 277.24 86.04C277.24 86.04 277.24 86.04 277.24 86.04L265.76 89.37C264.21 96.26 263.35 100.08 263.17 100.85C261.69 105.29 263.54 126.76 263.54 126.76C263.54 126.76 263.54 126.76 263.54 126.76C263.17 138.24 256.14 141.94 256.14 141.94C256.14 141.94 256.14 141.94 256.14 141.94C245.03 146.75 235.41 132.32 235.41 132.32C235.41 132.32 235.41 132.32 235.41 132.32C234.3 129.72 227.63 122.69 227.63 122.69C227.63 122.69 227.63 122.69 227.63 122.69C222.82 118.62 213.2 113.44 213.2 113.44C213.2 113.44 213.2 113.44 213.2 113.44C206.98 117.43 203.52 119.66 202.83 120.1C201.72 135.65 209.49 152.31 209.49 152.31C209.49 152.31 209.49 152.31 209.49 152.31C212.82 160.45 210.6 167.49 210.6 167.49C210.6 167.49 210.6 167.49 210.6 167.49C205.42 181.18 189.13 172.3 189.13 172.3C189.13 172.3 189.13 172.3 189.13 172.3C186.17 170.45 179.14 164.89 179.14 164.89C179.14 164.89 179.14 164.89 179.14 164.89C172.1 160.82 157.66 157.86 157.66 157.86C157.66 157.86 157.66 157.86 157.66 157.86C152.78 163.41 150.06 166.5 149.52 167.12C153.59 180.81 159.14 187.48 159.14 187.48C159.14 187.48 159.14 187.48 159.14 187.48C164.48 194.59 167.44 198.53 168.03 199.32C173.95 209.69 168.4 215.98 168.4 215.98C168.4 215.98 168.4 215.98 168.4 215.98C159.52 225.98 144.71 218.94 144.71 218.94C144.71 218.94 144.71 218.94 144.71 218.94C138.41 214.87 115.83 215.61 115.83 215.61C115.83 215.61 115.83 215.61 115.83 215.61L110.28 227.09C114.5 232.64 116.84 235.73 117.31 236.34C118.79 238.94 125.83 243.75 125.83 243.75C125.83 243.75 125.83 243.75 125.83 243.75C130.49 247.08 133.08 248.93 133.6 249.3C146.56 258.56 142.49 267.44 142.49 267.44C142.49 267.44 142.49 267.44 142.49 267.44C138.04 278.92 119.16 275.96 119.16 275.96C119.16 275.96 119.16 275.96 119.16 275.96C114.35 275.22 108.8 276.7 108.8 276.7C108.8 276.7 108.8 276.7 108.8 276.7C104.72 275.96 91.77 281.14 91.77 281.14C91.77 281.14 91.77 281.14 91.77 281.14L89.18 292.99L89.18 292.99Z",
    id: "coJ6mPUdS"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradienteTGfBF2D1",
    gradientUnits: "userSpaceOnUse",
    x1: -152.42,
    y1: 268.59,
    x2: 709.15,
    y2: 359.47
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7ccbe",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8daea9",
      stopOpacity: 1
    },
    offset: "5.924761%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#708d90",
      stopOpacity: 1
    },
    offset: "13.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#58747d",
      stopOpacity: 1
    },
    offset: "22.61%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#45616f",
      stopOpacity: 1
    },
    offset: "32.11%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#365466",
      stopOpacity: 1
    },
    offset: "42.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2a4c5f",
      stopOpacity: 1
    },
    offset: "55.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#22475c",
      stopOpacity: 1
    },
    offset: "70.56%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1f465b",
      stopOpacity: 1
    },
    offset: "100%"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M383.12 327.79C383.12 327.79 383.12 327.79 383.12 327.79C383.12 457.73 383.12 529.92 383.12 544.36C383.12 544.36 383.12 544.36 383.12 544.36C306.27 544.36 263.57 544.36 255.03 544.36C255.03 544.36 255.03 544.36 255.03 544.36C255.03 414.41 255.03 342.22 255.03 327.79C255.03 327.79 255.03 327.79 255.03 327.79C331.88 327.79 374.58 327.79 383.12 327.79Z",
    id: "b3FGBawhVp"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradienta43NHkxBh",
    gradientUnits: "userSpaceOnUse",
    x1: 254.98,
    y1: 436.26,
    x2: 382.95,
    y2: 436.26
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccb010",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3c900",
      stopOpacity: 1
    },
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8e000",
      stopOpacity: 1
    },
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8e000",
      stopOpacity: 1
    },
    offset: "100%"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M319.07 553.61C354.24 553.61 382.75 549.54 382.75 544.36C382.75 544.36 382.75 544.36 382.75 544.36C382.75 539.17 354.24 535.1 318.7 535.1C318.7 535.1 318.7 535.1 318.7 535.1C283.53 535.1 254.66 539.17 254.66 544.36C254.66 544.36 254.66 544.36 254.66 544.36C255.03 549.54 283.53 553.61 318.7 553.61C318.78 553.61 319.04 553.61 319.07 553.61Z",
    id: "fgD0C2OS"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradienta8uOwvCiCh",
    gradientUnits: "userSpaceOnUse",
    x1: 254.98,
    y1: 544.55,
    x2: 382.95,
    y2: 544.55
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccb010",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3c900",
      stopOpacity: 1
    },
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8e000",
      stopOpacity: 1
    },
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8e000",
      stopOpacity: 1
    },
    offset: "100%"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a22id3aipJ",
    opacity: 1,
    fill: "#ebecee",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a22id3aipJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cpd89SSHN",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cpd89SSHN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1AzV1Ef9P",
    opacity: 1,
    fill: "#ebecee",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1AzV1Ef9P",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#au45V8Mxs",
    opacity: 1,
    fill: "#ebecee",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#au45V8Mxs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1EmL9JX4",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1EmL9JX4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8HRSpFMh",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8HRSpFMh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c18pnjlSks",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c18pnjlSks",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bnO5Jg8ZK",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bnO5Jg8ZK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1c7QlrToI",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1c7QlrToI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cnYjCJ7kt",
    opacity: 1,
    fill: "#1f465b",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cnYjCJ7kt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1vV5oakOj",
    opacity: 1,
    fill: "url(#gradientatWxAMys2)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1vV5oakOj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1Km1NHy3J",
    opacity: 1,
    fill: "#f1da00",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1Km1NHy3J",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajA7fLWQP",
    opacity: 1,
    fill: "#083746",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajA7fLWQP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#coJ6mPUdS",
    opacity: 1,
    fill: "url(#gradienteTGfBF2D1)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#coJ6mPUdS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3FGBawhVp",
    opacity: 1,
    fill: "url(#gradienta43NHkxBh)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3FGBawhVp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fgD0C2OS",
    opacity: 1,
    fill: "url(#gradienta8uOwvCiCh)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fgD0C2OS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoB);
export default __webpack_public_path__ + "static/media/logo_b.ba1399567650ca2c5def537a560b656d.svg";
export { ForwardRef as ReactComponent };